module.exports = __webpack_public_path__ + "img/0Q3A4704_L_BlackMatted_MockedUp.86337b52.jpg";